import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { useCart } from "../context/CartContext";
import PaymentTrust from "../components/PaymentTrust";

export default function PayPalResult() {
  const [params] = useSearchParams();
  const { clear } = useCart();
  const [status, setStatus] = useState("checking");
  const token = params.get("token");
  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post(`/payments/paypal/capture/${encodeURIComponent(token)}`)
      .then(({ data }) => { if (data.payment_status === "paid") { setStatus("paid"); clear(); } else setStatus("error"); })
      .catch(() => setStatus("error"));
  }, [token, clear]);
  return <div className="pt-40 pb-32 min-h-[70vh] flex flex-col items-center text-center px-6">
    {status === "checking" && <><Loader2 size={48} className="animate-spin mb-6" stroke="var(--lo-rose)" /><h1 className="font-display text-4xl" style={{fontWeight:300}}>Confirmation du paiement PayPal...</h1></>}
    {status === "paid" && <><CheckCircle2 size={56} className="mb-6" stroke="var(--lo-rose)" /><h1 className="font-display text-5xl mb-4" style={{fontWeight:300}}>Merci pour votre commande</h1><p className="text-sm mb-10" style={{color:"var(--lo-muted)"}}>Votre paiement PayPal a bien été confirmé.</p><PaymentTrust compact /><Link to="/" className="btn-primary inline-flex items-center h-14 px-10">Retour à l'accueil</Link></>}
    {status === "error" && <><XCircle size={56} className="mb-6" stroke="#e08" /><h1 className="font-display text-4xl mb-4" style={{fontWeight:300}}>Un souci est survenu</h1><p className="text-sm mb-10" style={{color:"var(--lo-muted)"}}>Le paiement PayPal n'a pas pu être confirmé.</p><PaymentTrust compact /><Link to="/panier" className="btn-ghost inline-flex items-center h-14 px-10">Retour au panier</Link></>}
  </div>;
}
